<template>
  <a :href="'/partner/' + partner.slug" class="section-card" :class="{ 'section-card--hotel': isHotel }" @click="$emit('clicked')">
    <div class="section-card__image">
      <img :src="mainImage" :alt="partner.title" loading="lazy" class="section-card__img" v-if="mainImage" />
      <div class="section-card__overlay">
        <span v-if="isHotel" class="section-card__badge section-card__badge--hotel">Hotel</span>
        <span v-else-if="partner.type === 'experience'" class="section-card__badge section-card__badge--experience">
          Experience
        </span>
      </div>
    </div>
    <div class="section-card__content">
      <h3 class="section-card__title">{{ partner.title }}</h3>
      <div v-if="isHotel" class="section-card__hotel-meta">
        <span v-if="locationText">{{ locationText }}</span>
      </div>
      <p v-if="!isHotel && locationText" class="section-card__location">{{ locationText }}</p>
      <div class="section-card__meta">
        <span v-if="!isHotel && formattedPrice" class="section-card__price">{{ formattedPrice }}</span>
        <span v-if="isHotel && hasPerks" class="section-card__perks">Member perks</span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: { partner: { type: Object, required: true } },
  computed: {
    metadata() { return this.partner.metadata || {} },
    isHotel() { return this.partner.source === 'fora' },
    hasPerks() { return Array.isArray(this.metadata.perks) && this.metadata.perks.length > 0 },
    mainImage() {
      if (!Array.isArray(this.partner.images) || !this.partner.images.length) return ''
      const img = this.partner.images[0]
      if (typeof img === 'string') return img
      return img.medium || img.large || img.small || ''
    },
    locationText() {
      if (this.partner.city) return this.partner.city.name || this.partner.city.title
      if (this.partner.country) return this.partner.country.name
      return null
    },
    formattedPrice() {
      const label = this.partner.price_label
      if (!label) return null
      const match = label.match(/^from\s+([A-Z]{3})\s+([\d.]+)$/i)
      if (match) {
        const [, currency, amount] = match
        const num = parseFloat(amount)
        const formatted = num % 1 === 0 ? num.toString() : num.toFixed(2)
        return currency === 'USD' ? `From $${formatted}` : `From ${currency} ${formatted}`
      }
      return label
    }
  }
}
</script>
